import { useState, memo } from "react";
import { Box, Grid, Paper, GridProps } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import { DashInfoCardDetails } from "components/modals";
import CardIcon, { IconTypes } from "components/Icons/CardIcons";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    isClickable: {
      cursor: "pointer",
      transition: "all 0.2s",
      "&:hover": {
        background: "var(--grayLv6)",
        boxShadow: "var(--shadow)",
      },
    },
  })
);
interface DashInfoCardProps extends GridProps {
  title?: string;
  name: IconTypes | string;
  value?: string | number;
  elevation?: number;
  isClickable?: boolean;
  fontSizeTitle?: string;
  fontSizeValue?: string;
  fontWeightTitle?: number;
  fontWeightValue?: number;
  info?: { p: number; m: number; g: number; gg: number };
}

function DashInfoCardBreak({
  value,
  title = "",
  elevation = 1,
  isClickable = false,
  fontSizeTitle,
  info,
  name,
  fontSizeValue,
  fontWeightTitle,
  fontWeightValue,
  xs = 12,
  sm = 6,
  md = 3,
  lg,
  xl = 2,
  ...rest
}: DashInfoCardProps) {
  const [openDetails, setOpenDetails] = useState(false);
  const classes = useStyles();

  const handleClick = () => {
    if (isClickable) {
      setOpenDetails(true);
    }
  };

  return (
    <>
      <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} {...rest}>
        <Paper
          elevation={elevation}
          style={{ padding: "8px 12px" }}
          className={isClickable ? classes.isClickable : ""}
          onClick={handleClick}
        >
          <Grid container spacing={2}>
            {name && name !== "none" && (
              <Grid
                item
                container
                xs={3}
                alignItems="center"
                justifyContent="center"
              >
                <CardIcon name={name} />
              </Grid>
            )}

            <Grid
              item
              container
              xs={9}
              justifyContent={name !== "none" ? "flex-end" : "flex-start"}
            >
              <Box
                height="80px"
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                textAlign={name !== "none" ? "right" : "left"}
              >
                <span
                  style={{
                    fontSize: fontSizeTitle ? `${fontSizeTitle}` : "1.4rem",
                    fontWeight: fontWeightTitle ? fontWeightTitle : 400,
                    display: "block",
                    color: "var(--black)",
                  }}
                >
                  {title}
                </span>
                <span
                  style={{
                    fontSize: fontSizeValue ? `${fontSizeValue}` : "2.4rem",
                    fontWeight: fontWeightValue ? fontWeightValue : 600,
                    color: "var(--black)",
                  }}
                >
                  {value}
                </span>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <DashInfoCardDetails
        title={title}
        info={info ? info : { g: 0, gg: 1, m: 4, p: 5 }}
        open={openDetails}
        setOpen={setOpenDetails}
      />
    </>
  );
}

export default memo(DashInfoCardBreak);
